// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ULuQ","question":"styles_question__3mKZl","description":"styles_description__fvuxP"};